var map = {
	"./1_Corinthians.json": 6532,
	"./1_Corinthians_11.json": 6107,
	"./1_John.json": 755,
	"./1_Peter.json": 2524,
	"./1_Thessalonians.json": 3474,
	"./1_Timothy.json": 4412,
	"./2_Corinthians.json": 1165,
	"./2_John.json": 7844,
	"./2_Peter.json": 2205,
	"./2_Thessalonians.json": 6883,
	"./2_Timothy.json": 1721,
	"./3_John.json": 7373,
	"./Acts.json": 6199,
	"./Colossians.json": 8154,
	"./Ephesians.json": 2436,
	"./Galatians.json": 8262,
	"./Hebrews.json": 1010,
	"./James.json": 9086,
	"./John.json": 443,
	"./Jude.json": 2900,
	"./Luke.json": 2297,
	"./Mark.json": 4547,
	"./Matthew.json": 4060,
	"./Philemon.json": 9268,
	"./Philippians.json": 5539,
	"./Revelation.json": 8523,
	"./Romans.json": 5516,
	"./Titus.json": 3135,
	"./old-testament/1_Chronicles.json": 3104,
	"./old-testament/1_Kings.json": 4594,
	"./old-testament/1_Samuel.json": 7253,
	"./old-testament/2_Chronicles.json": 7951,
	"./old-testament/2_Kings.json": 5587,
	"./old-testament/2_Samuel.json": 7682,
	"./old-testament/Amos.json": 5582,
	"./old-testament/Daniel.json": 669,
	"./old-testament/Deuteronomy.json": 2137,
	"./old-testament/Ecclesiastes.json": 4836,
	"./old-testament/Esther.json": 1521,
	"./old-testament/Exodus.json": 6452,
	"./old-testament/Ezekiel.json": 801,
	"./old-testament/Ezra.json": 6496,
	"./old-testament/Genesis.json": 136,
	"./old-testament/Habakkuk.json": 3586,
	"./old-testament/Haggai.json": 6469,
	"./old-testament/Hosea.json": 2578,
	"./old-testament/Isaiah.json": 1349,
	"./old-testament/Jeremiah.json": 4745,
	"./old-testament/Job.json": 7429,
	"./old-testament/Joel.json": 6544,
	"./old-testament/Jonah.json": 4188,
	"./old-testament/Joshua.json": 6436,
	"./old-testament/Judges.json": 1170,
	"./old-testament/Lamentations.json": 2599,
	"./old-testament/Leviticus.json": 6892,
	"./old-testament/Malachi.json": 1471,
	"./old-testament/Micah.json": 2992,
	"./old-testament/Nahum.json": 3523,
	"./old-testament/Nehemiah.json": 7275,
	"./old-testament/Numbers.json": 8960,
	"./old-testament/Obadiah.json": 660,
	"./old-testament/Proverbs.json": 8341,
	"./old-testament/Psalms.json": 5346,
	"./old-testament/Ruth.json": 5167,
	"./old-testament/Song_of_Solomon.json": 3357,
	"./old-testament/Zechariah.json": 3991,
	"./old-testament/Zephaniah.json": 8846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;